import { createRequest, getAccessToken } from './config';

const request = createRequest();

export const Auth = {
  PasswordLogin: (email, Password) =>
    request.patch(`/auth/login/password/${email}`, Password),
  
  addPublicKey: (id) =>
    request.get(`/auth/addWebauthn/${id}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  addWebauthn: (id, data) =>
    request.patch(`/auth/addWebauthn/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  checkWebauthn: (id) =>
    request.get(`/auth/login/webauthn/${id}`),
  
  loginWebauthn: (id, data) =>
    request.patch(`/auth/login/webauthn/${id}`, data),
  
  saveWebAuthn: (id, data) =>
    request.patch(`/auth/savewebauthn/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
};

export default Auth;
